import React, { useEffect, useState } from "react";
import {
  Grid,
  TextField,
  Button,
  Tooltip,
  IconButton,
  Typography,
  Container,
  CssBaseline,
} from "@material-ui/core";
import InfoIcon from "@material-ui/icons/Info";
import { makeStyles } from "@material-ui/core/styles";
import overlayImage from "../../images/overlayImg.png";
import GTLOGO from "../../images/logo_dark.png";
import overlay from "../../images/overlay.png";
import { useDispatch } from "react-redux";
import { onResetPasswordSubmit, onValidateToken } from "./actions";
import Modal from "react-bootstrap/Modal";
import RingLoader from "react-spinners/RingLoader";
import { Field } from "redux-form";
import styles from "./signIn.module.css";
import StandalonePasswordField from "../../components/FormComponents/PasswordValidationField/StandalonePasswordField";

// const useStyles = makeStyles((theme) => ({
//   // '@global': {
//   //      body: {
//   //           backgroundColor: "#4a148c",
//   //           backgroundImage: `url(${overlayImage})`,
//   //           backgroundSize: "cover",
//   //           backgroundRepeat: "no-repeat",
//   //           backgroundPosition: "center",
//   //           color: "#ffffff",
//   //      },
//   // },

//   container: {
//     userSelect: "none",
//     //   height: "90vh",
//     //   width: "100vw",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     alignContent: "center",
//   },
//   fullHeight: {
//     //   height: "100%",
//   },
//   formContainer: {
//     backgroundColor: "#9581b2",
//     borderRadius: "20px",
//     // opacity: "0.9",
//     padding: "30px",
//     boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
//     //    minHeight: '600px',
//     maxWidth: "500px",
//     height: "100%",
//     marginTop: "1em",
//     marginLeft: "20px",
//     display: "flex",
//     flexDirection: "column",
//     justifyContent: "center",
//     alignContent: "center",
//     alignItems: "center",
//   },
//   imageContainer: {
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//     height: "100%",
//     marginRight: "20px",
//   },
//   inputField: {
//     marginBottom: theme.spacing(4),
//     margin: "0 auto 32px auto",
//     width: "60%",
//     backgroundColor: "#e8f0fe",
//     borderRadius: "5px",
//     "& label.Mui-focused": {
//       color: "#000",
//     },
//     "& .MuiOutlinedInput-root": {
//       "& fieldset": {
//         borderColor: "#6a1b9a",
//       },
//       "&:hover fieldset": {
//         borderColor: "#000",
//       },
//       "&.Mui-focused fieldset": {
//         borderColor: "#000",
//       },
//     },
//   },
//   infoIcon: {
//     marginLeft: theme.spacing(1),
//   },
//   resetPassword: {
//     color: "#ffffff",
//     // fontWeight: "bold",
//     fontSize: "1.5rem",
//     textAlign: "center",
//     marginBottom: theme.spacing(4),
//   },
//   backLink: {
//     // display: "block",
//     width: "30%",
//     margin: "0 auto",
//     marginTop: theme.spacing(2),
//     textAlign: "center",
//     color: "#ffffff",
//     fontSize: "1rem",
//     fontWeight: "bold",
//     // "&:hover": {
//     //   color: "#4a148c",
//     //   textDecoration: "underline",
//     // },
//     // textDecoration: "none",
//   },
//   logoImage: {
//     width: "60%",
//     display: "block",
//     margin: "0 auto",
//     marginBottom: theme.spacing(5),
//   },

//   image: {
//     width: "100%",
//     maxWidth: "500px",
//   },
//   submitButton: {
//     width: "60%",
//     height: "50px",
//     backgroundColor: "#4f2d7f",
//     color: "white",
//     fontWeight: "bold",
//     textTransform: "uppercase",
//     // borderRadius: "5px",
//     // margin: "0 auto",
//     border: "none",
//     margin: "0 auto",
//     outline: "none !important",
//     "&:focus": {
//       outline: "none",
//     },
//     "&:hover": {
//       backgroundColor: "#4f2d7f",
//     },
//   },
//   customTooltip: {
//     backgroundColor: "#6a1b9a",
//     width: "280px",
//     color: "#fff",
//     fontSize: "14px",
//   },
//   arrow: {
//     color: "#6a1b9a",
//   },

//   //   "@media (max-width: 768px)": {
//   //     imageContainer: {
//   //       display: "none",
//   //     },
//   //   },
// }));

const useStyles = makeStyles((theme) => ({
  // '@global': {
  //      body: {
  //           backgroundColor: "#4a148c",
  //           backgroundImage: `url(${overlayImage})`,
  //           backgroundSize: "cover",
  //           backgroundRepeat: "no-repeat",
  //           backgroundPosition: "center",
  //           color: "#ffffff",
  //      },
  // },

  container: {
    userSelect: "none",
    //   height: "90vh",
    //   width: "100vw",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    alignContent: "center",
  },
  fullHeight: {
    //   height: "100%",
  },
  formContainer: {
    backgroundColor: "#9581b2",
    borderRadius: "20px",
    // opacity: "0.9",
    padding: "30px",
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
    //  minHeight: '600px',
    maxWidth: "34%",
    height: "100%",
    // marginTop: "1em",
    // marginLeft: "20px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
  },
  imageContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    marginRight: "20px",
  },
  // inputField: {
  //   marginBottom: theme.spacing(4),
  //   margin: "0 auto 32px auto",
  //   width: "60%",
  //   backgroundColor: "#e8f0fe",
  //   borderRadius: "5px",
  //   "& label.Mui-focused": {
  //     color: "#000",
  //   },
  //   "& .MuiOutlinedInput-root": {
  //     "& fieldset": {
  //       borderColor: "#6a1b9a",
  //     },
  //     "&:hover fieldset": {
  //       borderColor: "#000",
  //     },
  //     "&.Mui-focused fieldset": {
  //       borderColor: "#000",
  //     },
  //   },
  // },
  // inputField: {
  //   width: "60%",
  //   margin: "0 auto 32px auto",
  //   borderRadius: "5px",
  //   marginBottom: "16px",

  //   // Remove background from outer container
  //   backgroundColor: "transparent",

  //   // Apply background only to the input box
  //   "& .MuiOutlinedInput-root": {
  //     backgroundColor: "#e8f0fe",
  //     borderRadius: "5px",
  //   },
  //   "& label.Mui-error": {
  //     color: "black",
  //   },
  //   // Force the asterisk to be black
  //   "& .MuiFormLabel-asterisk": {
  //     color: "black",
  //   },
  // },
inputField: {
  // width: '60%',
  // margin: '0 auto 16px auto',
  borderRadius: '5px',

  '& .MuiOutlinedInput-root': {
    backgroundColor: '#e8f0fe',
    borderRadius: '5px',
  },

  // Override all label states to stay black
  '& .MuiInputLabel-root': {
    color: 'black',
  },
  '& .MuiInputLabel-root.Mui-focused': {
    color: 'black',
  },
  '& .MuiInputLabel-root.Mui-error': {
    color: 'black',
  },
  '& .MuiFormLabel-asterisk': {
    color: 'black',
  },
},

  infoIcon: {
    marginLeft: theme.spacing(1),
  },
  resetPassword: {
    color: "#ffffff",
    // fontWeight: "bold",
    fontSize: "1.5rem",
    textAlign: "center",
    marginBottom: theme.spacing(4),
  },
  backLink: {
    // display: "block",
    width: "30%",
    margin: "0 auto",
    marginTop: theme.spacing(2),
    textAlign: "center",
    color: "#ffffff",
    fontSize: "1rem",
    fontWeight: "bold",
    // "&:hover": {
    //   color: "#4a148c",
    //   textDecoration: "underline",
    // },
    // textDecoration: "none",
  },
  logoImage: {
    width: "60%",
    display: "block",
    margin: "0 auto",
    marginBottom: theme.spacing(5),
  },

  image: {
    width: "80%",
    maxWidth: "500px",
  },
  submitButton: {
    marginTop:'0.5em',
    width: "40%",
    height: "33px",
    backgroundColor: "#4f2d7f",
    color: "white",
    fontWeight: "bold",
    textTransform: "uppercase",
    // borderRadius: "5px",
    // margin: "0 auto",
    border: "none",
    margin: "0 auto",
    outline: "none !important",
    "&:focus": {
      outline: "none",
    },
    "&:hover": {
      backgroundColor: "#4f2d7f",
    },
  },
  customTooltip: {
    backgroundColor: "#6a1b9a",
    width: "280px",
    color: "#fff",
    fontSize: "14px",
  },
  arrow: {
    color: "#6a1b9a",
  },
  helperTextNormal: {
    backgroundColor: "transparent !important", // Remove blue bg
    marginTop: 4,
    color: "white", // Optional: standard error red
  },

  //   "@media (max-width: 768px)": {
  //     imageContainer: {
  //       display: "none",
  //     },
  //   },
}));

const ResetPassNew = (props) => {
  const classes = useStyles();
  const [password, setPassword] = useState("");
  const dispatch = useDispatch();
  const [token, setToken] = useState();
  const [isTokenInValid, setIsTokenInValid] = useState(true);
  const [isShowloading, setIsShowLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [modalText, setmodalText] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errors, setErrors] = useState({});
  const [passwordValidationResults, setPasswordValidationResults] = useState({});
  const [passwordStrength, setPasswordStrength] = useState(0);
  const minLength = 8;
  const maxLength = 20;
  // Handle password validation results from the component
  const handlePasswordChange = (passwordValue, validationResults, strength) => {
    setPasswordValidationResults(validationResults);
    setPasswordStrength(strength);
  };

  // Check if password meets all requirements
  const isPasswordValid = () => {
    return Object.values(passwordValidationResults).every(result => result.valid);
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    setToken(token);
    validateToken(token);
  }, [window.location.search]);

  const validateToken = (token) => {
    dispatch(
      onValidateToken({
        resetToken: token,
      })
    )
      .then(() => {
        setIsShowLoading(false);
        setIsTokenInValid(false);
      })
      .catch((err) => {
        console.log(err, "err in token");
        setIsShowLoading(false);

        setIsTokenInValid(true);
      });
  };

  //   const onSubmitForm = (val) => {
  //     dispatch(
  //       onResetPasswordSubmit({
  //         password: password,
  //         confirmPassword: confirmPassword,
  //         resetToken: token,
  //       })
  //     )
  //       .then((res) => {
  //         setmodalText("Your password is reset successfully");
  //         setShowModal(true);
  //       })
  //       .catch((err) => {
  //         setmodalText("Something went wrong please try again!!");
  //         setShowModal(true);
  //       });
  //   };
  const onSubmitForm = (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      return;
    }
    
    // Use the new validation system
    if (!isPasswordValid()) {
      return;
    }
    
    dispatch(
      onResetPasswordSubmit({
        password,
        confirmPassword,
        resetToken: token,
      })
    )
      .then(() => {
        setmodalText("Your password is reset successfully");
        setShowModal(true);
      })
      .catch(() => {
        setmodalText("Something went wrong. Please try again!");
        setShowModal(true);
      });
  };

  const handleModalClose = () => {
    setShowModal(false);
    props.history.push("/");
  };

  const validate = (values) => {
    const errors = {};
    const requiredFields = ["newPass", "confirmPass"];

    requiredFields.forEach((field) => {
      if (!values[field]) {
        errors[field] = "Required";
      }
    });

    if (values.newPass) {
      if (values.newPass.length < 8 || values.newPass.length > 20) {
        errors.newPass = "Password must be between 8 and 20 characters.";
      } else if (
        !/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9])/.test(values.newPass)
      ) {
        errors.newPass =
          "Password must include uppercase, lowercase, number and special character.";
      }
    }

    if (
      values.newPass &&
      values.confirmPass &&
      values.newPass !== values.confirmPass
    ) {
      errors.confirmPass = "Passwords do not match.";
    }

    return errors;
  };

  return (
    <div
      className={styles.loginPage}
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        alignContent: "center",
        justifyContent: "center",
        // overflow:'hidden'
      }}
    >
      <Container className={classes.container}>
        {/*CssBaseline is used to reset the default styles of the browser or else use index.css or App.css*/}
        <CssBaseline />
        {isShowloading && (
          <div className="sweet-loading">
            <RingLoader size={100} color={"#123abc"} loading={true} />
          </div>
        )}

        <>
          <Grid
            container
            spacing={3}
            alignItems="center"
            justifyContent="center"
          >
            {/* Left Side Image */}
            <Grid
              item
              xs={12}
              md={6}
              className={`${classes.imageContainer} ${classes.fullHeight}`}
            >
              <img
                src={overlayImage}
                alt="Reset Password"
                className={classes.image}
              />
            </Grid>
            {/* Right Side Form */}
            <Grid
              item
              xs={12}
              md={6}
              className={`${classes.formContainer} ${classes.fullHeight}`}
            >
              <div style={{ textAlign: "center", marginBottom: "20px" }}>
                <img src={GTLOGO} alt="logo" className={classes.logoImage} />
                <Typography
                  variant="h5"
                  gutterBottom
                  className={classes.resetPassword}
                >
                  {" "}
                  Reset Password
                </Typography>
              </div>

              <form
                //   onSubmit={handleSubmit}
                onSubmit={onSubmitForm}
                autoComplete="off"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {/* <TextField
                  type="password"
                  label="New Password"
                  variant="outlined"
                  className={classes.inputField}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                   error={isValidPassword(password).errors}
                  helperText={isValidPassword(password).errors}
                  InputProps={{
                    endAdornment: (
                      <Tooltip
                      title={isValidPassword(password).errors}
                      placement="top"
                      classes={{ tooltip: classes.customTooltip, arrow: classes.arrow }}
                      arrow
                 >
                      <IconButton className={classes.infoIcon} style={{ color: isValidPassword(password).isValid > 0 ? "green" : "red" }}>
                           <InfoIcon />
                      </IconButton>
                 </Tooltip>
                    ),
                  }}
                  required
                /> */}
                {/* <TextField
  type="password"
  label="New Password"
  variant="outlined"
  className={classes.inputField}
  value={password}
  onChange={(e) => setPassword(e.target.value)}
  error={!isValidPassword(password).isValid}
  helperText={!isValidPassword(password).isValid ? isValidPassword(password).errors : " "}
  required
/> */}
                {/* <TextField
  type="password"
  label="New Password"
  variant="outlined"
  className={classes.inputField}
  value={password}
  onChange={(e) => setPassword(e.target.value)}
  error={password !== "" && !isValidPassword(password).isValid}
  helperText={
    password !== ""
      ? (!isValidPassword(password).isValid
          ? isValidPassword(password).errors
          : " ")
      : " "
  }
  required
/> */}
                {/* <TextField
  type="password"
  label="New Password"
  variant="outlined"
  className={classes.inputField}
  value={password}
  onChange={(e) => setPassword(e.target.value)}
  error={password !== "" && !isValidPassword(password).isValid}
  helperText={
    password !== "" && !isValidPassword(password).isValid
      ? isValidPassword(password).errors
      : undefined
  }
  required
/> */}

<div>
                <StandalonePasswordField
                  label="New Password"
                  variant="outlined"
                  className={classes.inputField}
                  value={password}
                  margin="dense"
                  onChange={(e) => setPassword(e.target.value)}
                  onPasswordChange={handlePasswordChange}
                  error={password !== "" && !isPasswordValid()}
                  helperText={
                    password !== "" && !isPasswordValid() ? (
                      <span className={classes.helperTextNormal}>
                        Password does not meet requirements
                      </span>
                    ) : undefined
                  }
                  required
                /></div>

                {/* <TextField
                  type="password"
                  label="Confirm Password"
                  variant="outlined"
                  className={classes.inputField}
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  InputProps={{
                    endAdornment: (
                      <Tooltip
                      title={isValidPassword(confirmPassword).errors}

                      placement="top"
                      classes={{ tooltip: classes.customTooltip, arrow: classes.arrow }}
                      arrow
                 >
                      <IconButton className={classes.infoIcon} style={{ color: isValidPassword(confirmPassword).isValid > 0 ? "green" : "red" }}>
                           <InfoIcon />
                      </IconButton>
                 </Tooltip>
                    ),
                  }}
                  required
                /> */}
                {/* <Tooltip
                  title="New Password and Confirm Password should be same"
                  disableHoverListener={password === confirmPassword}
                  placement="top"
                  arrow
                > */}
                  {/* <TextField
                    type="password"
                    label="Confirm Password"
                    variant="outlined"
                    className={classes.inputField}
                    margin="dense"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    error={
                      confirmPassword !== "" && confirmPassword !== password
                    }
                    helperText={
                      confirmPassword !== "" && confirmPassword !== password
                        ? "Passwords do not match"
                        : undefined
                    }
                    required
                  /> */}
<TextField
  type="password"
  label="Confirm Password"
  variant="outlined"
  className={classes.inputField}
  style={{width:"62%"}}
  margin="dense"
  value={confirmPassword}
  onChange={(e) => setConfirmPassword(e.target.value)}
  error={
    confirmPassword !== "" && confirmPassword !== password
  }
  helperText={
    confirmPassword !== "" && confirmPassword !== password
      ? <span className={classes.helperTextNormal}>Passwords do not match</span>
      : undefined
  }
  required
/>

                  <Button
                    className={classes.submitButton}
                    type="submit"
                    variant="contained"
                    color="primary"
                    fullWidth
                    style={{
                      textTransform:'capitalize',
                      backgroundColor:
                        !isPasswordValid() ||
                        password !== confirmPassword ||
                        password === ""
                          ? "grey"
                          : "#4f2d7f",
                      color:
                        !isPasswordValid() ||
                        password !== confirmPassword ||
                        password === ""
                          ? "white"
                          : "#ffffff",
                      cursor:
                        !isPasswordValid() ||
                        password !== confirmPassword ||
                        password === ""
                          ? "not-allowed"
                          : "pointer",
                    }}
                  >
                    {password !== confirmPassword ? "Submit" : "Reset Password"}
                  </Button>
                {/* </Tooltip> */}
              </form>
              {/* <Button
              color="success"
              style={{marginTop:'1em'}}
              onClick={() => {
                props.history.push("/");
              }}
            >
              Back to login
            </Button> */}
              <Button
                color="success"
                style={{ marginTop: "1em" }}
                onClick={() => {
                  props.history.push("/");
                }}
              >
                Back to login
              </Button>
              {/* <a href="/" className={classes.backLink}>
                              Back to Login
                         </a> */}
            </Grid>
          </Grid>
        </>

        {/* {!isShowloading && isTokenInValid && (
                  <div style={{ padding: "2rem" }}>
                    <h3>Sorry this link is expired</h3>
                    <Button
                      color="success"
                      onClick={() => {
                        props.history.push("/");
                      }}
                    >
                      Go Back to login page
                    </Button>
                  </div>
                )} */}

        <Modal show={showModal} onHide={handleModalClose}>
          <Modal.Header>
            <Modal.Title>Password Reset Confirmation</Modal.Title>
          </Modal.Header>
          <Modal.Body>{modalText}</Modal.Body>
          <Modal.Footer>
            <Button
              variant="primary"
              className="standard_purple_button"
              onClick={handleModalClose}
            >
              Ok
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>
    </div>
  );
};

export default ResetPassNew;
